import { useQuery } from '@tanstack/react-query';
import { cn } from '@/lib/utils';
import { listWilayas } from '@/services/tiers';

export interface WilayaSelectProps {
  value: number | null | undefined;
  onChange: (wilayaId: number | null) => void;
  placeholder?: string;
  className?: string;
  id?: string;
}

/**
 * Liste déroulante des 58 wilayas algériennes (depuis l'API, mise en cache).
 * Réutilisable dans tous les formulaires (tiers, entreprise, chantiers…).
 */
export function WilayaSelect({ value, onChange, placeholder = '— Wilaya —', className, id }: WilayaSelectProps) {
  const { data: wilayas } = useQuery({
    queryKey: ['wilayas'],
    queryFn: listWilayas,
    staleTime: Infinity, // table de référence : ne change jamais
  });

  return (
    <select
      id={id}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
      className={cn(
        'flex h-10 w-full rounded-md border border-border bg-surface-secondary px-3 text-sm text-content-primary',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent',
        className,
      )}
    >
      <option value="">{placeholder}</option>
      {wilayas?.map((w) => (
        <option key={w.id} value={w.id}>
          {w.code} · {w.nom_fr}
        </option>
      ))}
    </select>
  );
}
